import styled from 'styled-components';
import { Link, Typography } from '@experian-uk/corvetteuk-common-ui';

import downloadIcon from './assets/download.svg';

export const BreachBenefitsContainer = styled.div`
  background: white;
  border-radius: 4px;
  margin: -1.5rem auto 0;
  padding: ${({ theme }) => theme.base.expSpacingXSmall};
  text-align: center;

  ${({ theme: { media } }) => media('15', `
    margin: -2rem auto 0;
  `)};

  ${({ theme: { media } }) => media('20', `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0.9375rem auto;
    padding: ${({ theme }) => theme.base.expSpacingSmall};
    text-align: left;
  `)};
`;

export const SmallText = styled(Typography.Copy.SmallText)`
  display: block;
  margin: 20px 0;
  font-weight: 300;
  font-size: 0.875rem;
  text-align: center;
  color: ${props => props.theme.colors.experianDarkGrey};
`;

export const PanelTitle = styled(Typography.Copy.Text)`
  text-align: center;
`;

export const FactSheetLink = styled(Link.Anchor)`
  align-items: center;
  display: flex;

  &:before {
    content: url(${downloadIcon});
    height: 31px;
    margin-right: .875rem;
    width: 29px;
  }
`;

export const FooterContent = styled.footer`
  align-items: center;
  display: flex;
  flex: 100%;
  padding: 3rem 0 1.25rem;
  margin-top: auto;
  width: 100%;

  img {
    width: 2.8125rem;
    height: 2.8125rem;
    vertical-align: middle;
  }

  a {
    vertical-align: middle;
    margin: 0 auto;
    text-align: center;
  }

  ${({ theme }) => theme.media('20', `
    padding: 1.25rem 1rem;
  `)}
`;
